import { render, staticRenderFns } from "./WidgetNonconformance.vue?vue&type=template&id=b7aba788"
import script from "./WidgetNonconformance.vue?vue&type=script&lang=js"
export * from "./WidgetNonconformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports